import {
  type FavoriteVehicle,
  FulfillmentKeyMap,
  InventoryTypeId,
  type InventoryVehicle
} from '@carvana/merch-contracts';
import sortVehiclesByRecency from './sortVehiclesByRecency';
import defaultVehicle from '../constants/defaultVehicle';

/**
 * Search doesn't return sold vehicles, so sold favorites are rebuilt from the
 * favorites payload and the result is put back into favorites order.
 */
export default function mergeFavoritesWithSearchResults(
  favoriteVehicles: FavoriteVehicle[],
  vehiclesFromSearch: InventoryVehicle[]
): InventoryVehicle[] {
  const vehiclesIncludingSold = favoriteVehicles.reduce<InventoryVehicle[]>(
    (acc, vehicle, index: number) => {
      if (vehicle.saleStatus === 'Sold') {
        acc.push({
          ...defaultVehicle,
          ...vehicle,
          fulfillmentType: FulfillmentKeyMap[vehicle.fulfillmentType],
          previousPrice: 0,
          price: vehicle.price
            ? { ...defaultVehicle.price, ...vehicle.price }
            : undefined,
          vehicleInventoryType: InventoryTypeId.Core,
          vehicleTags: []
        });
      }

      if (index < vehiclesFromSearch.length) {
        acc.push(vehiclesFromSearch[index]);
      }

      return acc;
    },
    []
  );

  return sortVehiclesByRecency(
    vehiclesIncludingSold,
    favoriteVehicles.map(v => v.vehicleId)
  );
}
